import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { queryClient } from 'providers/AllProviders';
import { createBusinessApiKey, deleteBusinessApiKey, getBusinessApiKeyNew, getBusinessApiKeys } from './api';
import { BusinessApiKey, BusinessApiKeyNewResponse, BusinessApiKeyRequest, BusinessApiKeysListResponse } from './types';

type ListOptions = Omit<UseQueryOptions<BusinessApiKeysListResponse, Error>, 'queryKey' | 'queryFn'>;
type NewOptions = Omit<UseQueryOptions<BusinessApiKeyNewResponse, Error>, 'queryKey' | 'queryFn'>;

export function useGetBusinessApiKeys(params?: Record<string, unknown>, options?: ListOptions) {
  return useQuery<BusinessApiKeysListResponse>({
    queryKey: ['business_api_keys', params],
    queryFn: () => getBusinessApiKeys(params),
    ...options
  });
}

export function useGetBusinessApiKeyNew(options?: NewOptions) {
  return useQuery<BusinessApiKeyNewResponse>({
    queryKey: ['business_api_key_new'],
    queryFn: () => getBusinessApiKeyNew(),
    ...options
  });
}

export function useCreateBusinessApiKey() {
  return useMutation({
    mutationFn: (payload: BusinessApiKeyRequest) => createBusinessApiKey(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['business_api_keys'],
        refetchType: 'active'
      });
    }
  });
}

export function useDeleteBusinessApiKey() {
  return useMutation({
    mutationFn: (id: number | string) => deleteBusinessApiKey(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['business_api_keys'],
        refetchType: 'active'
      });
    }
  });
}

export type { BusinessApiKey };
